module.exports = __webpack_public_path__ + "c0c0cf3f20f7784509d0d7f2e0ab0f43.png";